import { useState } from 'react';

import { Controls, ControlsButton } from '@/components/Controls';
import FullScreenButton from '@/components/FullScreenButton';
import { TableHeader } from '@/components/Table';
import VariationFour from '@/pages/CoverImagesGenerator/components/VariationFour';
import VariationOne from '@/pages/CoverImagesGenerator/components/VariationOne';
import VariationThree from '@/pages/CoverImagesGenerator/components/VariationThree';
import VariationTwo from '@/pages/CoverImagesGenerator/components/VariationTwo';

const variations = [
  { slug: 'one', name: 'L/R + text' },
  { slug: 'two', name: 'Img + text' },
  { slug: 'three', name: 'Img + comment' },
  { slug: 'four', name: 'Simple text' },
];

const Generator = () => {
  const [type, setType] = useState('one');

  const renderVariation = () => {
    switch (type) {
      case 'one':
        return <VariationOne inArticle />;
      case 'two':
        return <VariationTwo inArticle />;
      case 'three':
        return <VariationThree inArticle />;
      case 'four':
        return <VariationFour inArticle />;
      default:
        return <VariationOne inArticle />;
    }
  };
  return (
    <>
      <TableHeader>
        <Controls>
          {variations.map((item, index) => (
            <ControlsButton
              key={index}
              active={type === item.slug}
              onClick={() => setType(item.slug)}
            >
              {item.name}
            </ControlsButton>
          ))}
        </Controls>
        <FullScreenButton />
      </TableHeader>
      {renderVariation()}
    </>
  );
};

export default Generator;
